/**
 * matchMedia helpers that work on Safari 13 and older Samsung Internet,
 * which implement addListener/removeListener instead of addEventListener.
 */

type MediaChangeListener = (event: MediaQueryListEvent | MediaQueryList) => void;

export function addMediaQueryListener(media: MediaQueryList, listener: MediaChangeListener): void {
  if (typeof media.addEventListener === 'function') {
    media.addEventListener('change', listener as EventListener);
    return;
  }
  (media as MediaQueryList & { addListener?: (l: MediaChangeListener) => void }).addListener?.(listener);
}

export function removeMediaQueryListener(media: MediaQueryList, listener: MediaChangeListener): void {
  if (typeof media.removeEventListener === 'function') {
    media.removeEventListener('change', listener as EventListener);
    return;
  }
  (media as MediaQueryList & { removeListener?: (l: MediaChangeListener) => void }).removeListener?.(listener);
}
